/*
 * WP REST Request Wrapper
 */

import axios from 'axios';

interface RequestConfig {
  url: string;
  method: 'get';
  data?: object;
  params?: object;
  headers?: {};
}

// API url and key
const API_URL = process.env.REACT_APP_WPREST_URL;

// Create axios client and set defaults
const client = axios.create({
  baseURL: API_URL,
});

// Return response data
const onSuccess = (response: any): any => {
  return response.data;
};

// Show notification message on error
const onError = (error: any): any => {
  return error;
};

// Axios wrapper with default success and error actions
const WPREST = async (options: RequestConfig): Promise<any> => {
  return client(options)
    .then(onSuccess)
    .catch(onError);
};

export default WPREST;
